export default class FiveKwhSwiperOne {
    constructor({ wrapEl, pcEl, mbEl }) {
        this.wrapDOM = document.querySelector(wrapEl)
        this.PCDOM = document.querySelector(pcEl)
        this.MBDOM = document.querySelector(mbEl)
        this.pcEl = pcEl
        this.mbEl = mbEl
        this.wrapEl = wrapEl;
        this.init = this.init.bind(this)
        if (this.PCDOM && this.MBDOM) {
            this.init()
            window.addEventListener('resize', this.init)
        }
    }

    init() {
        const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
        if (clientWidth < 1024) {
            if (!this.swiperMB) {
                this.MBDOM && this.initMB();
            }
        } else {
            if (!this.swiperPC) {
                this.PCDOM && this.initPC();
            }
        }
    }
    initSwiper(targetEl, dataset, thumbsSwiper = null, navigation) {
        const { autoplay, delay, size } = dataset;
        this.config = {
            loop: size > 1,
            autoplay: autoplay === 'true',
            autoplayDelay: delay,
        };

        const swiperConfig = {
            autoplay: this.config.autoplay ? {
                delay: this.config.autoplayDelay * 1000,
                disableOnInteraction: false
            } : false,
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: true,
            allowTouchMove: false,
            simulateTouch: false,
            followFinger: false,
            loop: this.config.loop,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1
            },
            on: {
                resize: function () {
                    setTimeout(() => {
                        this.update(); // 更新 swiper
                    }, 500);
                },
                slideChange: function () {
                    this.update();

                    if (thumbsSwiper) {
                        const activeIndex = this.realIndex;
                        thumbsSwiper.slideToLoop(activeIndex);
                    }
                },
                slideChangeTransitionEnd: function () {
                    const curSlide = Array.from(this.slides).filter((it) =>
                        it.classList.contains("swiper-slide-active")
                    );
                    const curImgs = $(curSlide).find("img");
                    // 兜底防止白屏，处理所有图片
                    curImgs.each(function() {
                        if (this) {
                            this.classList.remove("lazyloading");
                            this.classList.add("lazyloaded");
                        }
                    });
                },
            }
        };

        if (thumbsSwiper) {
            swiperConfig.thumbs = { swiper: thumbsSwiper };
        }
        if (navigation) {
            swiperConfig.navigation = {
                nextEl: navigation.nextEl,
                prevEl: navigation.prevEl
            };
        }
        return new Swiper(targetEl, swiperConfig);
    }

    initPC() {
        const { autoplay, delay, size } = this.PCDOM?.dataset;
        const thumbsSwiper = new Swiper(this.wrapDOM.querySelector(`.five-kwh-one-content`), {
            slidesPerView: 3,
            loop: true,
            centeredSlides: true,
            clickable: false,
            allowTouchMove: false,
            simulateTouch: false,
            followFinger: false,
            navigation: {
                nextEl: `${this.wrapEl} .swiper-one-button-next`,
                prevEl: `${this.wrapEl} .swiper-one-button-prev`
            }
        });

        const navigation = {
            nextEl: `${this.wrapEl} .swiper-one-button-next`,
            prevEl: `${this.wrapEl} .swiper-one-button-prev`
        };

        this.swiperPC = this.initSwiper(this.pcEl, this.PCDOM?.dataset, thumbsSwiper, navigation);
    }


    initMB() {
        const navigation = {
            nextEl: `${this.wrapEl} .swiper-one-button-next`,
            prevEl: `${this.wrapEl} .swiper-one-button-prev`
        }
        this.swiperMB = this.initSwiper(this.mbEl, this.MBDOM?.dataset,null,navigation);
    }
}
